export default {
  cleanFilters: 'Clean filters',
  titleButton: 'Filters',
  filtersTitle: 'Filters',
  cleanFilter: 'Clean filters',
  apply: 'Apply',
  stateFilterLabel: 'State',
  sponsorFilterLabel: 'Sponsor',
  dateFilter: 'Dates',
  dateFieldLabel: 'Date range',
  documentationLabel: 'Documentation',
  documentation: 'Documentation: {satisfiesDocumentsPolicy}'
}
